import { GroupsView } from '../../../../../components/worldcup/GroupsView/GroupsView';

export default function CompetitionGroupsScreen() {
  return <GroupsView />;
}
